var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedirectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H1V12H11V7H12V12C11.9996 12.2651 11.8945 12.5196 11.707 12.707C11.5196 12.8945 11.2651 12.9996 11 13H1C0.734893 12.9996 0.480428 12.8945 0.292969 12.707C0.10551 12.5196 0.000357171 12.2651 0 12V2C0.000357171 1.73489 0.10551 1.48043 0.292969 1.29297C0.480428 1.10551 0.734893 1.00036 1 1H6V2ZM13 0V5H12V1.70703L7.70703 6L7 5.29297L11.293 1H8V0H13Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectWhite);
export default __webpack_public_path__ + "static/media/RedirectWhite.714e86faa25252bc757bb51f3123c56c.svg";
export { ForwardRef as ReactComponent };